module.exports = __webpack_public_path__ + "img/giginput.0843323b.png";